import { Controller } from "@hotwired/stimulus"
import { Popover } from "mdb-ui-kit"
import { useIntersection } from "stimulus-use"

// When it is initially hidden or when turbo frame inserts it, we need to
// reinitialize. We are using `.update` since hidden components are already
// initialized. So for all data-mdb-popover-init add this controller. For example:
//
//    <div data-mdb-popover-init data-controller="mdb-popover-appear">
export default class extends Controller {
  connect() {
    console.log("mdb-popover-appear connect")
    useIntersection(this)
  }

  appear(entry) {
    console.log("mdb-popover-appear appear")
    new Popover(this.element).update()
  }
}
